import * as React from 'react';
import { styled, css } from '../theme-provider';
import { useTableContext } from './table';
const StyledTableHeader = styled.th.withConfig({ displayName: "StyledTableHeader", componentId: "sc-ubv4p3" }) `display:table-cell;background-color:${({ theme, emphasized }) => theme.colors.background[emphasized ? 'tertiary' : 'primary']};color:${({ theme }) => theme.colors.content.primary};text-align:start;padding:${({ theme }) => theme.size.static200} 0;border-bottom:${({ theme }) => theme.size.border.heavy} solid ${({ theme }) => theme.colors.border.divider};word-break:break-all;&[scope='row']{border-bottom-width:${({ theme }) => theme.size.border.light};}${({ fixedHeaderColumn, theme }) => fixedHeaderColumn &&
    css `
			&[scope='col']:first-of-type {
				border-bottom: unset;
				background: ${theme.colors.background.primary};
			}

			&:first-of-type {
				position: sticky;
				${theme.direction === 'rtl' ? 'right: 0;' : 'left: 0;'}

				mask: linear-gradient(black 0 0)
						${theme.direction === 'rtl' ? 'right' : 'left'},
					linear-gradient(
							${theme.direction === 'rtl' ? '270deg' : '90deg'},
							black,
							transparent
						)
						${theme.direction === 'rtl' ? 'left' : 'right'};
				mask-size:
					calc(100% - ${theme.size.static350}) 100%,
					${theme.size.static350} 100%;
				mask-repeat: no-repeat;
			}
		`}`;
export const TableHeader = ({ children, emphasized = false, }) => {
    const headerRef = React.useRef(null);
    const { showNavigation, tableHeadersRef, fixedHeaderColumn } = useTableContext();
    React.useEffect(() => {
        const currentHeader = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current;
        if (!currentHeader) {
            return;
        }
        if (currentHeader.closest('thead')) {
            currentHeader.setAttribute('scope', 'col');
        }
        else if (currentHeader.closest('tbody')) {
            currentHeader.setAttribute('scope', 'row');
        }
        else {
            currentHeader.setAttribute('scope', '');
        }
    }, [headerRef]);
    React.useEffect(() => {
        const currentHeader = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current;
        if (!currentHeader)
            return;
        const tableHeaders = tableHeadersRef === null || tableHeadersRef === void 0 ? void 0 : tableHeadersRef.current;
        if (!tableHeaders)
            return;
        const isCurrentHeaderInsideThead = currentHeader.closest('thead');
        const isFirstHeader = !currentHeader.previousElementSibling;
        /*	Push the table header ref into the tableHeadersRef array if it is inside the thead and has children.
            This is needed in order to prevent the empty th (used when the th with scope "row" are needed) as well as the th with scope "row" from being counted*/
        if (isCurrentHeaderInsideThead && !(isFirstHeader && fixedHeaderColumn)) {
            tableHeaders.push(currentHeader);
        }
    }, [headerRef, tableHeadersRef, fixedHeaderColumn]);
    return (React.createElement(StyledTableHeader, { emphasized: emphasized, fixedHeaderColumn: fixedHeaderColumn, ref: headerRef, showNavigation: showNavigation }, children));
};
